import { render, staticRenderFns } from "./bannerpositiondetails.vue?vue&type=template&id=2c7673a2"
import script from "./bannerpositiondetails.vue?vue&type=script&lang=js"
export * from "./bannerpositiondetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports